import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  Grid, Typography, Divider, IconButton, FormControl,
  FormGroup, FormControlLabel, Checkbox, Switch, Container, Button
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { AutocompleteForm, FormatInputNumero, SelectAsincronico, SelectFree, TextFieldAutoComplete } from 'components';
import { FormDropZone } from 'components';
import { GetApp } from '@material-ui/icons';
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { useFormContext } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red'
    }
  },
  paper: {
    height: 140,
    width: 100,
  },
  controlStyle: {
    padding: theme.spacing(2),
  },

}));
const TiposCtl = [
  { idopc: 1, opcion: "MEJORA" },
  { idopc: 2, opcion: "INCIDENCIA" },
  { idopc: 3, opcion: "NUEVO MÓDULO" },
  { idopc: 4, opcion: "AJUSTE" },
];
const campoRequerido = { required: { value: true, message: 'Campo requerido' } };

export default function FormularioRequerimientosV2(props) {
  const { datoS, respuesta, cerrarAdvertencia, edicionEspecial, accion, tipo, setCargando, ctlg, catalogos } = props; //bucarEquipo
  const classes = useStyles();
  const [ctl, setCtl] = useState(ctlg);
  const isEdicion = datoS.estatusPropuesta ? (datoS.estatusPropuesta == 6 ? false : true) : false;
  const [dataReq, setDataReq] = useState({});
  const [Tipo, setTipo] = useState({});

  // const [aplicarReq, setAplicarReq] = useState(true);
  // let arrNvlbono = [{ value: 1, label: 'SILVER' }, { value: 2, label: 'GOLD' }];
  const { register, errors, control, watch } = useFormContext();
  const servicios = {
    get: () => {
      serviciosSolicitudes.getDocumentos(
        (data) => {
          setCtl({
            ...ctl,
            infoarchivos: data.infoarchivos,
          });
        },
        setCargando,
        { idsolicitud: datoS.idsolicitud }
      );
    },
  };

  const descargarDocs = () => {
    setCargando(true);
    ctl.infoarchivos.forEach((element, i) => {
      //for (var i = 1; i <= ctl.infoarchivos.length; i++) {
      (function (index) {
        setTimeout(function () {

          const link = document.createElement("a");
          // link.href = "https://dashboard.gphsis.com/back/Login/whatever/" + element.idarchivo;
          link.href = "http://localhost/dashboardback/Login/whatever/"+element.idarchivo;
          link.download = 'filename';
          link.click();

          if ((ctl.infoarchivos.length - 1) == i)
            setTimeout(function () {
              setCargando(false);
            }, 4000);
        }, (i + 1) * 3000);
      })(i);
    });
  };
  useEffect(() => {
    servicios.get(setDataReq, setCargando, {});
  }, []); //dataReq
  return (
    <Container maxWidth={false}>
      <Grid container className={classes.root} spacing={2}>
        <Grid item md={4} xs={6}>
          <Typography variant="body2">
            <b>TIPO DE SOLICITUD :</b>{" "}
            {datoS.ntipo_solicitud || "N/D"}
          </Typography>
        </Grid>
        <Grid item md={3} xs={6}>
          <Typography variant="body2">
            <b>PRIORIDAD :</b> {datoS.nprioridad || "N/D"}
          </Typography>
        </Grid>
        <Grid item md={4} xs={6}>
          <Typography variant="body2">
            <b>SISTEMA :</b> {datoS.sistema || "N/D"}
          </Typography>
        </Grid>
        {ctl.infoarchivos?.length > 0 && <Grid item md={1} xs={6}>
          <IconButton
            type="button"
            title="descargar archivos"
            size="small"
            onClick={descargarDocs}
            aria-label="descargar"
          >
            <GetApp />
          </IconButton>
        </Grid>
        }
        <Grid container item spacing={2}>
          <Grid item md={6} xs={12}>
            <Grid item md={12} xs={12}>
              <Typography variant="body2">
                <b>TÍTULO :</b> {datoS.titulo || "N/D"}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography variant="body2">
                <b>SOLICITANTE :</b> {datoS.solicitante || "N/D"}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography variant="body2">
                <b>SOLICITUD :</b> {datoS.problematica || "N/D"}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography variant="body2">
                <b>CORREO DE CONTACTO :</b> {datoS.correo || "N/D"}
              </Typography>
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <Grid item md={12} xs={12}>
              <Typography variant="body2">
                <b>DESCRIPCIÓN DE LA SOLICITUD :</b>{" "}
                {datoS.desc_solicitud || "N/D"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item md={3} xs={6}>
        <AutocompleteForm
          variant="outlined"
          control={control}
          name="tipo_solicitud"
          label="TIPO DE SOLICITUD"
          defaultValue={datoS?.tipo_solicitud ? {idopc:datoS?.tipo_solicitud,opcion:datoS.ntipo_solicitud} : null}
          rules={campoRequerido}
          error={errors.tipo_solicitud?.message}
          options={TiposCtl}
          optionSelected={{ id: "idopc", label: "opcion" }}
        />
        </Grid>
        <Grid item md={3} xs={6}>
          <AutocompleteForm
            control={control}
            name="responsable"
            label="RESPONSABLE"
            rules={campoRequerido}
            error={errors.responsable?.message}
            options={ctl?.responsables}
            optionSelected={{
              label: 'npersona',
              id: 'idpersona'
            }}
            disabled={isEdicion}
            variant="outlined"
          />
        </Grid>
        <Grid item md={3} xs={6}>
            <TextField 
              label="# HORAS TESTEO" 
              variant="outlined" 
              fullWidth
              size="small"
              name="hrs_testeo"
              type="number"
              error={errors.hrs_testeo} 
              inputRef={register(campoRequerido)}
              helperText={errors.hrs_testeo?.message}
            />
          </Grid>
        <Grid item md={3} xs={6}>
          <Grid container item spacing={2}>
            <Grid item md={8} xs={6}>
              <Typography>Aplicar requerimientos</Typography>
            </Grid>
            <Grid item md={3} xs={6}>
              <Switch
                id='aplicarReq '
                inputRef={register}
                // checked={watch('aplicarReq')}
                // onChange={(e, value) => { setValue('aplicarReq', value) }}
                name="aplicarReq"
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
        {watch('aplicarReq') &&
          <Grid item md={12} xs={12}>
            <FormDropZone
              rules={{}}
              name="filefield"
              control={control}
              label="control" />
          </Grid>
        }
      </Grid>
    </Container>
  );
}
